/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbRespLayout_viewer = {|
  +searchBrowse?: ?{| |};
  +user?: ?{| |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchSb",
      "type": "Boolean",
      "defaultValue": true
    },
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "page",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespLayout_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespComponents_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedTrackingContainer_user",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_user",
              "args": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchSb",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first",
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "localeOrigin",
              "variableName": "localeOrigin",
              "type": "String"
            },
            {
              "kind": "Variable",
              "name": "page",
              "variableName": "page",
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "uriRef",
              "variableName": "uriRef",
              "type": "String"
            }
          ],
          "concreteType": "SearchBrowseQueryConnection",
          "name": "searchBrowse",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SbSharedRefetchContainer_searchBrowse",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbRespComponents_searchBrowse",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbSharedHead_searchBrowse",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "SbSharedTrackingContainer_searchBrowse",
              "args": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
